import {

  OrganizationsThemeColor,

} from '@organization/models'


import { mainAxios } from './axios/mainAxios'

export const organizations = {

  //todo: depreched, check if will be added or not
  patchOrganizationsChangById: async ({
    id,
    body
  }: {
    id: number
    body: OrganizationsThemeColor
  }) => {
    return await mainAxios.patch(`/organizations/change/${id}/`, body)
  }
}
